import * as types from './mutation-types';

export default {
    [types.FETCH_MAINPOPUP_LIST](state, payload) {
        state.mainPopupList = payload || [];
    },
};